/* 🤖 this file was generated by svg-to-ts */
export const matIconNetworkCell: {
  name: 'network-cell';
  data: string;
} = {
  name: 'network-cell',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z"/></svg>`
};
